import { useContext, useEffect, useState } from "react";
import Layout from "../../Layouts";
import AdminContext from "../../Services/Admin";
import EditIcon from "../../Assets/Icons/outline/edit-2.svg";
import Modal from "../../Components/Modal";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import TaskModal from "./TaskModal";
import { toast } from "react-toastify";
import Deadline from "../../Components/Deadline";
import TaskIcon from "../../Assets/Icons/outline/task-square-black.svg";
import MaximizeIcon from "../../Assets/Icons/outline/maximize-3.svg";
import EyeTaskIcon from "../../Assets/Icons/outline/eye.svg";
import AddTaskIcon from "../../Assets/Icons/outline/profile-add.svg";
import moment from "moment";
import Timeline from "./Timeline";
import ProjectModal from "../Dashboard/ProjectModal";
import DetailTaskModal from "./DetailTaskModal";
import ScoringModal from "./ScoringModal";
import Button from "../../Components/Button";
import FullPage from "./FullPage";
import ActionPage from "./ActionPage";
import CloseProjectModal from "./CloseProjectModal";

const schema = yup
	.object({
		name: yup.string().required(),
		level: yup.string().required(),
		client_name: yup.string().required(),
		deadline: yup.string().required(),
		hex_code: yup.string().required(),
		m_project_incentive_type_id: yup.string().required(),
	})
	.required();

const schemaTask = yup
	.object({
		name: yup.string().required(),
		m_groups_id: yup.string().required(),
		deadline: yup.string().required(),
	})
	.required();

const schemaCloseProject = yup
	.object({
		is_goal: yup.string().required(),
		// bonus: yup.number().required(),
	})
	.required();

function ProjectPage() {
	const { loading, getAllMaster, addMaster, addMasterForm } = useContext(AdminContext);
	const [modal, setModal] = useState({
		show: false,
		id: "",
		type: "",
		data: {},
		dataDetail: {},
	});

	const [dataContributor, setDataContributor] = useState([]);
	const [dataContributorProject, setDataContributorProject] = useState([]);
	const [showMonth, setShowMonth] = useState(false);
	const [monthArray, setMonthArray] = useState([]);
	const [selectedMember, setSelectedMember] = useState(null);
	const [fullPage, setFullPage] = useState(false);
	const [currentMonth, setCurrentMonth] = useState(moment());
	const [dataProject, setDataProject] = useState([]);
	const [line, setLine] = useState([]);

	const defaultValues = {
		name: "",
		description: "",
		deadline: "",
		level: "Master Project",
		client_name: "",
		t_projects_id: "",
		hex_code: "#ffffff",
		m_project_incentive_type_id: "",
	};

	const defaultValuesTask = {
		name: "",
		description: "",
		m_groups_id: "",
		deadline: "",
	};

	const defaultValuesCloseProject = {
		isGoal: "false",
		// bonus: 0,
	};

	const {
		register,
		handleSubmit,
		reset,
		control,
		setValue,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues,
	});

	const {
		register: registerTask,
		handleSubmit: handleSubmitTask,
		reset: resetTask,
		control: controlTask,
		watch: watchTask,
		setValue: setValueTask,
		formState: { errors: errorsTask },
	} = useForm({
		resolver: yupResolver(schemaTask),
	});

	const {
		register: registerCloseProject,
		handleSubmit: handleSubmitCloseProject,
		reset: resetCloseProject,
		control: controlCloseProject,
		watch: watchCloseProject,
		setValue: setValueCloseProject,
		formState: { errors: errorsCloseProject },
	} = useForm({
		resolver: yupResolver(schemaCloseProject),
		defaultValues: {
			// bonus: 0,
			is_goal: "false",
		},
	});

	const { register: registerScore, handleSubmit: handleSubmitScore, reset: resetScore } = useForm({});

	const handleShow = (id, type, data, dataDetail) => {
		setModal({
			show: true,
			id: id,
			type: type,
			data: data,
			dataDetail: dataDetail,
		});
	};

	const handleClose = () => {
		setModal({ show: false, id: "", type: "", data: {}, dataDetail: {} });
		reset(defaultValues);
		resetTask(defaultValuesTask);
		resetCloseProject();
		setDataContributorProject([]);
		resetScore();
	};

	const addAction = async (values) => {
		let response = await addMaster(`project/${modal?.data ? "update/" + modal?.data?.id : "create"}`, values);
		if (!response?.message) {
			toast.success((modal?.data ? "Update" : "Add") + " Project Success");
			getDataProject();
			handleClose();
			if (!modal?.data) {
				handleShow(response?.success?.id, "add task", response?.success);
			}
		}
	};

	const addActionTask = async (values) => {
		// return;
		const formData = new FormData();
		formData.append("name", values.name);
		formData.append("description", values.description);
		formData.append("deadline", values.deadline);
		formData.append("m_groups_id", values.m_groups_id);

		dataContributor?.map((item) => {
			formData.append("m_users_id[]", item.id);
		});

		let response = await addMasterForm(
			`project/task/${modal?.id}/${modal?.dataDetail ? "update/" + modal?.dataDetail?.id : "create"}`,
			formData,
		);
		if (!response?.message) {
			toast.success((modal?.dataDetail ? "Update" : "Add") + " Task Success");
			getDataProject();
			handleClose();
		}
	};

	const addActionScore = async (values) => {
		const formData = new FormData();
		values.score?.map((item) => {
			formData.append("score[]", item);
		});

		let response = await addMasterForm("project/task/" + modal?.id + "/update-score/", formData);
		if (!response?.message) {
			toast.success("Update Task Success");
			getDataProject();
			handleClose();
		}
	};

	const deleteAction = async () => {
		const res = await addMaster(
			modal?.dataDetail === "task"
				? `project/task/${modal?.id}/${modal?.id ? "delete/" + modal?.data : "create"}`
				: `project/delete/${modal?.id}`,
		);
		if (!res?.err) {
			toast.success("Delete Data Success");
			getDataProject();
			handleClose();
		}
	};

	const closeProjectAction = async (values) => {
		const formData = new FormData();
		formData.append("is_goal", values.is_goal);
		// formData.append("bonus", values.bonus);
		formData.append(
			"contributors",
			JSON.stringify(
				dataContributorProject.contributors.map((item) => ({
					user_id: item.id,
					points: item.points,
				})),
			),
		);

		let response = await addMasterForm("project/close/" + modal?.id, formData);
		// return;
		if (!response?.err) {
			toast.success("Close Project Success");
			getDataProject();
			handleClose();
		}
	};

	useEffect(() => {
		if (currentMonth) {
			let currentMonths = moment(currentMonth, "MM/dd/yyyy HH:mm:ss.SSS`");
			var datesBetween = [];

			for (let i = 1; i <= 5; i++) {
				const date = currentMonths.clone().subtract(5, "months");
				datesBetween.push(moment(date, "MM/dd/yyyy HH:mm:ss.SSS`").clone().add(i, "months"));
			}
			for (let i = 1; i <= 4; i++) {
				const date = currentMonths.clone().add(i, "months");
				datesBetween.push(date);
			}

			setMonthArray(datesBetween);
			setShowMonth(false);
			getDataProject(selectedMember);
		}
	}, [currentMonth, selectedMember]);

	const getDataProject = async (member) => {
		const newData = await getAllMaster(
			`project?month=${currentMonth?.format("YYYY-MM-DD")} ${member ? "&" + member : ""}`,
		);
		if (newData) {
			setDataProject(newData);
			setLine(Array.from(Array(newData?.maxData).keys()));
		}
	};

	const checkAllowSubmit = () => {
		if (modal?.type !== "close project") return true;
		if (modal?.type === "close project") {
			return modal?.data?.status === "Completed" ? true : false;
		}
	};

	return (
		<>
			{fullPage ? (
				<FullPage
					currentMonth={currentMonth}
					dataProject={dataProject}
					line={line}
					handleShow={handleShow}
					setCurrentMonth={setCurrentMonth}
					setShowMonth={setShowMonth}
					showMonth={showMonth}
					monthArray={monthArray}
					fullPage={fullPage}
					setFullPage={setFullPage}
					selectedMember={selectedMember}
					setSelectedMember={setSelectedMember}
				/>
			) : (
				<Layout>
					<div className="flex">
						<div className="w-[calc(100%-350px)] me-4">
							<div className="flex items-center justify-between">
								<div className="flex items-center mb-5">
									<img src={TaskIcon} className="w-[40px] h-[40px] me-5" alt="" />
									<div className="text-[28px] pt-1 font-semibold capitalize">Project Task</div>
								</div>
								<ActionPage
									setCurrentMonth={setCurrentMonth}
									setShowMonth={setShowMonth}
									showMonth={showMonth}
									currentMonth={currentMonth}
									monthArray={monthArray}
									fullPage={fullPage}
									setFullPage={setFullPage}
									selectedMember={selectedMember}
									setSelectedMember={setSelectedMember}
								/>
							</div>
							<div className="relative">
								<Timeline currentMonth={currentMonth} dataProject={dataProject} line={line} handleShow={handleShow} />
								<div className="absolute right-10 bottom-10 flex flex-col z-40">
									{(localStorage.getItem("role") === "Superadmin" ||
										localStorage.getItem("role") === "Manager" ||
										localStorage.getItem("role") === "Lead Designer") && (
										<button
											onClick={() => handleShow(null, "start project")}
											type="button"
											className="p-3 shadow-[0_0_3px_2px_rgba(0,0,0,0.3)] bg-white rounded-xl mb-10"
										>
											<img src={EditIcon} alt="" className="w-[40px] h-[40px]" />
										</button>
									)}
									<button
										onClick={() => setFullPage(true)}
										type="button"
										className="p-3 shadow-[0_0_3px_2px_rgba(0,0,0,0.3)] bg-white rounded-xl"
									>
										<img src={MaximizeIcon} alt="" className="w-[40px] h-[40px]" />
									</button>
								</div>
							</div>
						</div>
						<div className="w-[350px]">
							<Deadline />
						</div>
					</div>
				</Layout>
			)}

			<Modal
				icon={modal?.type === "detail project" ? EyeTaskIcon : EditIcon}
				modal={modal}
				name={
					modal?.type === "start project"
						? "Add Project"
						: modal?.type === "update project"
							? "Update Project"
							: modal?.type === "detail project"
								? "Detail Project"
								: modal?.type === "update task"
									? "Update Task"
									: modal?.type === "add task"
										? "Add Task"
										: modal?.type === "score"
											? "Scoring"
											: modal?.type === "close project"
												? "Close Project"
												: "Delete Data"
				}
				handleClose={handleClose}
				submit={
					modal?.type === "start project" || modal?.type === "update project"
						? handleSubmit(addAction)
						: modal?.type === "score"
							? handleSubmitScore(addActionScore)
							: modal?.type === "delete"
								? deleteAction
								: modal?.type === "close project"
									? handleSubmitCloseProject(closeProjectAction)
									: handleSubmitTask(addActionTask)
				}
				loading={loading}
				width="w-[800px]"
				disabledSubmit={!checkAllowSubmit()}
				footer={
					modal?.type === "detail project" && (
						<>
							{modal?.data?.is_open === 1 && (
								<div className="flex items-center justify-end">
									<div className=" me-5">
										<Button
											className="text-base py-2 pt-3 text-start"
											width={150}
											icon={AddTaskIcon}
											onClick={() => {
												handleShow(modal?.id, "add task", modal?.data);
											}}
										>
											Add Task
										</Button>
									</div>
									<button
										type="button"
										onClick={handleClose}
										className="py-1 pt-2 w-[150px] rounded-xl bg-white border border-black font-semibold hover:bg-black hover:text-white"
									>
										Done
									</button>
								</div>
							)}
							{modal?.data?.is_open === 0 && (
								<div className="flex items-center justify-end">
									<button
										type="button"
										onClick={handleClose}
										className="py-1 pt-2 w-[150px] rounded-xl bg-white border border-black font-semibold hover:bg-black hover:text-white"
									>
										Done
									</button>
								</div>
							)}
						</>
					)
				}
			>
				{(modal?.type === "start project" || modal?.type === "update project") && (
					<ProjectModal
						register={register}
						errors={errors}
						control={control}
						setValue={setValue}
						data={modal?.data}
						reset={reset}
					/>
				)}
				{(modal?.type === "add task" || modal?.type === "update task") && (
					<TaskModal
						errors={errorsTask}
						register={registerTask}
						control={controlTask}
						watch={watchTask}
						dataContributor={dataContributor}
						setDataContributor={setDataContributor}
						dataProject={modal?.data}
						dataTask={modal?.dataDetail}
						reset={resetTask}
						setValue={setValueTask}
					/>
				)}
				{modal?.type === "detail project" && (
					<DetailTaskModal data={modal?.data} getData={getDataProject} handleShow={handleShow} />
				)}
				{modal?.type === "score" && (
					<ScoringModal register={registerScore} dataTask={modal?.dataDetail} reset={resetTask} />
				)}
				{modal.type === "delete" && <div className="text-xl">Are you sure you want to delete this item?</div>}
				{/* {modal.type === "close project" && <div className="text-xl">Are you sure you want to close this project?</div>} */}
				{modal.type === "close project" && (
					<CloseProjectModal
						errors={errorsCloseProject}
						register={registerCloseProject}
						control={controlCloseProject}
						watch={watchCloseProject}
						dataContributor={dataContributorProject}
						setDataContributor={setDataContributorProject}
						dataProject={modal?.data}
						dataTask={modal?.dataDetail}
						reset={resetCloseProject}
						setValue={setValueCloseProject}
					/>
				)}
			</Modal>
		</>
	);
}

export default ProjectPage;
